import { useEffect, type FC, type PropsWithChildren } from "react";
import { useVcf } from "@/entities/vcf";
import { useAuth } from "@/services/auth";

export const ImportVcfInitializer: FC<PropsWithChildren> = ({ children }) => {
  const {
    state: { vcfIsLoading },
    methods: { getImportVcfStatusHandler },
  } = useVcf();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated && vcfIsLoading) {
      getImportVcfStatusHandler();
    }
  }, [vcfIsLoading, isAuthenticated]);

  return <>{children}</>;
};
